<template lang='pug'>
  button.bf-button.actionable.component(
    unselectable='on'
    :type='type'
    :title='title'
    :disabled='disabled'
  )
    slot( name='icon' )
    slot( name='text' )
</template>

<script>
  export default {
    name: 'bf-button.component',

    props: {
      type: { type: String, default: 'button' },
      disabled: { type: Boolean, default: false },
      title: String
    }
  }
</script>

<style scoped lang='stylus'>
  .bf-button
    background var(--bg-nav)
    border-radius 5px
    padding 6px 20px
    text-align center
    color var(--clr-light)
    transition all 320ms
    font-weight normal
    &:hover, &:focus
      color white
      box-shadow var(--shadow-box)
    &:active
      transform scale(.8)
      
  [type=reset]
    background rgb( 176 176 176 )
    color rgb( 32 32 32 )

  .bf-button.link
    padding 0
    a
      display block
      padding 8px

  .bf-button.bright
    background rgb( 0 175 255 )

  .bf-button.wide
    padding 8px 24px
    width auto

  .bf-button.tall
    padding-top 10px
    padding-bottom 10px

  .bf-button.taller
    padding-top 12px
    padding-bottom 12px

  .bf-button.bold
    font-weight bold
    letter-spacing .5px

  .bf-button.secondary
    background rgb( 200 200 200 )

  .bf-button.tertiary
    background rgb( 240 240 240 )
    color rgb( 128 128 128 )

  .bf-button.narrow
    width auto
    padding-left 36px
    padding-right 36px

  .bf-button.narrower
    width auto
    padding-left 32px
    padding-right 32px

  .bf-button.narrowest
    width auto
    padding-left 24px
    padding-right 24px

  .bf-button.small
    font-size .84em

  .bf-button.large
    font-size 1.2em

  .bf-button.full
    width auto
    padding 10px 28px

  .bf-button.clear
    background 0
    color var(--bg-nav)
    font-weight bold
    border 1.5px solid var(--bg-nav)

  .bf-button.icon-only
    font-size 2.1em
    padding-top 0
    padding-bottom 0

  .bf-button.combo
    display flex
    align-items center
    justify-content center
    .icon
      margin-right 8px

  .bf-button.inactive, .bf-button:disabled
    background rgb( 220 220 220 )
    color rgb( 90 90 90 )
    box-shadow none
    cursor auto
    &:hover, &:focus
      // color inherit
      box-shadow none
    &:active
      transform scale(1)
  
  .bf-button.save
    margin-left 30px
    
  .bf-button.auto
    width auto
    padding 8px 24px

  .bf-button.hilite
    animation glowing 1300ms 5

  @keyframes glowing 
    0% 
      background-color #1F4590
      box-shadow 0 0 3px #1F4590
    50% 
      background-color #21c7ed
      box-shadow 0 0 15px #21c7ed
    100% 
      background-color #1F4590
      box-shadow: 0 0 3px #1F4590
</style>
